import { useState } from 'react';

export default function FinalStep({ contextFields, onSubmit, submitting, error }) {
  const [email, setEmail] = useState('');
  const [industry, setIndustry] = useState('');
  const [employees, setEmployees] = useState('');
  const [revenue, setRevenue] = useState('');
  const [topTools, setTopTools] = useState('');
  const [mainConcern, setMainConcern] = useState('');

  // A context dropdown only appears when this questionnaire actually defines
  // options for it — leaving a list blank in the builder hides that field.
  const industries = contextFields?.industries || [];
  const employeeRanges = contextFields?.employees || [];
  const revenueRanges = contextFields?.revenue || [];

  // Only email is required to see the score. Everything else is optional
  // context that helps Alex tailor the follow-up.
  const valid = email.includes('@');

  function handleSubmit(e) {
    e.preventDefault();
    if (!valid) return;
    onSubmit({
      email,
      context: { industry, employees, revenue, topTools, mainConcern },
    });
  }

  return (
    <form onSubmit={handleSubmit}>
      <h2>Last step — see your score</h2>
      <p className="muted">
        Drop your email to see your results. The rest is optional — it helps frame your follow-up.
      </p>

      {error && <div className="error">{error}</div>}

      <div className="field-grid">
        <div className="field">
          <label htmlFor="email">Your email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            required
          />
        </div>
        {industries.length > 0 && (
          <div className="field">
            <label htmlFor="industry">Industry (optional)</label>
            <select id="industry" value={industry} onChange={(e) => setIndustry(e.target.value)}>
              <option value="">Select…</option>
              {industries.map((i) => <option key={i} value={i}>{i}</option>)}
            </select>
          </div>
        )}
        {employeeRanges.length > 0 && (
          <div className="field">
            <label htmlFor="employees">Employees (optional)</label>
            <select id="employees" value={employees} onChange={(e) => setEmployees(e.target.value)}>
              <option value="">Select…</option>
              {employeeRanges.map((i) => <option key={i} value={i}>{i}</option>)}
            </select>
          </div>
        )}
        {revenueRanges.length > 0 && (
          <div className="field">
            <label htmlFor="revenue">Annual revenue (optional)</label>
            <select id="revenue" value={revenue} onChange={(e) => setRevenue(e.target.value)}>
              <option value="">Select…</option>
              {revenueRanges.map((i) => <option key={i} value={i}>{i}</option>)}
            </select>
          </div>
        )}
      </div>

      <div className="field">
        <label htmlFor="topTools">Top 3 software tools you rely on most (optional)</label>
        <input
          id="topTools"
          type="text"
          value={topTools}
          onChange={(e) => setTopTools(e.target.value)}
          placeholder="e.g. QuickBooks, HubSpot, Slack"
        />
      </div>

      <div className="field">
        <label htmlFor="mainConcern">
          What&apos;s the main thing you&apos;re trying to figure out right now? (optional)
        </label>
        <textarea
          id="mainConcern"
          rows={3}
          value={mainConcern}
          onChange={(e) => setMainConcern(e.target.value)}
          placeholder="One sentence is plenty."
        />
      </div>

      <div className="nav-row">
        <span className="muted small">
          Your results live at a private link — you can download or bookmark them there.
        </span>
        <button type="submit" disabled={!valid || submitting}>
          {submitting ? 'Calculating…' : 'See my score'}
        </button>
      </div>
    </form>
  );
}
